module.exports = __webpack_public_path__ + "img/whatsapp-sm.2defbe05.png";